/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import "../components/style.css";
// import Axios from "axios";
// import LoadingPage from "../components/LoadingPage";
import Swal from "sweetalert2";
import bg from "../img/bg.png";
import No_image from "../img/No_Image.jpg";
// import jwt from "jsonwebtoken";
import { checkGroupsUser, getlocalStorage, f } from "../function/functionALL";

require("moment/locale/th");

const ModalAbsent = ({
  Tester,
  checkstatus,
  show,
  onClose,
  onSave,
}) => {
  const [reason, setReason] = useState("0");
  const [comment, setComment] = useState("");
  const handleClose = () => {
    onClose();
  };
  const navigate = useNavigate();
  const { Token, DataToken_ } = getlocalStorage();
  const handleAbsent = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "ยืนยันการเปลี่ยนแปลงข้อมูล?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "ยกเลิก",
      confirmButtonText: "ยืนยัน",
    }).then((result) => {
      if (result.isConfirmed) {
        if (reason === "0") {
          const data = {
            absent_comment: " ",
            absent_reason: "0",
          };
          onSave(data, Tester);
        } else if (
          reason === "1" ||
          reason === "2" ||
          reason === "3" ||
          reason === "4"
        ) {
          const data = {
            absent_comment:
              comment === undefined ? Tester.absent_comment : comment,
            absent_reason:
              reason === "0" ? String(Tester.absent_reason) : String(reason),
          };
          onSave(data, Tester);
        }
      }
    });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop={true}
        centered
        keyboard={false}
      >
        <Modal.Body>
          <div className=" rounded ">
            <div className="p-sm-3">
              <div className="col-sm-12 col-xs-12">
                <div className="card-body rounded">
                  <div className="row d-flex p-2">
                    <div
                      className="fw-bold text-center"
                      style={{ fontSize: "25px" }}
                    >
                      กรณีไม่เข้ารับการทดสอบ
                    </div>
                  </div>
                  {/* <!-- No Labels Form --> */}
                  <div>
                    <div
                      className="px-3 flex-lg-row card shadow-lg mx-auto"
                      style={{
                        backgroundImage: `url(${bg})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "100% 100%",
                        color: "#000000",
                        width: "100%",
                        borderRadius: "10px",
                      }}
                    >
                      {/* {loading ? (
                          "Loading..."
                        ) : ( */}

                      <div className="p-3 col-12 col-lg-4 ">
                        {/* <img src={person} alt="Profile" className="rounded" width="100%" height="100%" /> */}
                        <img
                          src={
                            Tester?.tester_image
                              ? process.env.REACT_APP_API_IMG +
                                Tester.tester_image
                              : No_image
                          }
                          alt="Profile"
                          className="rounded "
                          style={{
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                          }}
                        />
                      </div>
                      <div className="p-sm-3 p-1 col-12 col-lg-8 mb-1">
                        <div
                          className="tab-pane fade show active profile-overview"
                          id="profile-overview"
                        >
                          <div className="col-12 col-sm-12">
                            <h5
                              className="fw-bold text-center"
                              style={{ color: "#000000" }}
                            >
                              ข้อมูลปัจจุบัน
                            </h5>
                          </div>
                          <div
                            className="p-3 col-12 col-sm-12"
                            style={{ fontSize: "14px" }}
                          >
                            <div className="col-12 col-sm-12  ms-2 d-flex">
                              <div className="col-4 col-sm-3 fw-bold">
                                ชื่อ :{" "}
                              </div>
                              <div className="col-8 col-sm-9 label">
                                {/* {Tester.tester_fullname} */}
                                {Tester?.tester_fullname}
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 ms-2 d-flex">
                              <div className="col-4 col-sm-3 fw-bold">
                                ตำแหน่ง :{" "}
                              </div>
                              <div className="col-8 col-sm-9 label">
                                {Tester?.tester_position}
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 ms-2 d-flex">
                              <div className="col-4 col-sm-3 fw-bold">
                                สังกัด :{" "}
                              </div>
                              <div className="col-8 col-sm-9 label">
                                {Tester?.work_unit_shortname}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 ms-2 d-flex">
                              <div className="col-4 col-sm-3 fw-bold">
                                อายุ :{" "}
                              </div>
                              <div className="col-8 col-sm-9 label">
                                {Tester?.tester_age} ปี
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="" style={{ height: "250px" }}>
                      <div className="mb-1" style={{ fontSize: "16px" }}>
                        <label
                          className="col-12 mb-1"
                          style={{ fontSize: "18px", fontWeight: "bold" }}
                        >
                          เนื่องจาก
                        </label>

                        <label className="col-3 text-center">
                          <input
                            type="radio"
                            name="reason"
                            value="1"
                            onChange={(e) => setReason(e.target.value)}
                            defaultChecked={
                              Tester?.absent_reason === 1 ? true : false
                            }
                            disabled={checkstatus === 0}
                          />{" "}
                          ราชการ
                        </label>
                        <label className="col-3 text-center">
                          <input
                            type="radio"
                            name="reason"
                            value="2"
                            onChange={(e) => setReason(e.target.value)}
                            defaultChecked={
                              Tester?.absent_reason === 2 ? true : false
                            }
                            disabled={checkstatus === 0}
                          />{" "}
                          ศึกษา
                        </label>
                        <label className="col-3 text-center">
                          <input
                            type="radio"
                            name="reason"
                            value="3"
                            onChange={(e) => setReason(e.target.value)}
                            defaultChecked={
                              Tester?.absent_reason === 3 ? true : false
                            }
                            disabled={checkstatus === 0}
                          />{" "}
                          ป่วย
                        </label>
                        <label className="col-3 text-center">
                          <input
                            type="radio"
                            name="reason"
                            value="4"
                            onChange={(e) => setReason(e.target.value)}
                            defaultChecked={
                              Tester?.absent_reason === 4 ? true : false
                            }
                            disabled={checkstatus === 0}
                          />{" "}
                          อื่น ๆ
                        </label>
                      </div>
                      <div
                        className="mt-3"
                        style={{ fontSize: "18px", fontWeight: "bold" }}
                      >
                        <label className="">เพิ่มเติม (ถ้ามี) </label>
                      </div>
                      <input
                        type="text"
                        className="form-control mt-2"
                        id="inputText9"
                        name="inputText9"
                        onChange={(e) => setComment(e.target.value)}
                        defaultValue={Tester?.absent_comment}
                        disabled={checkstatus === 0}
                      ></input>
                      <label
                        className="col-12 mt-2"
                        style={{ fontSize: "18px", fontWeight: "bold" }}
                      >
                        ล้างข้อมูล(เลือกเมื่อต้องการให้เข้ารับการทดสอบ)
                      </label>
                      <label className="col-12" style={{ fontSize: "18px" }}>
                        <input
                          type="radio"
                          name="reason"
                          value="0"
                          onChange={(e) => setReason(e.target.value)}
                          defaultChecked={
                            Tester?.absent_reason === 0 ? true : false
                          }
                          disabled={checkstatus === 0}
                        />{" "}
                        เข้ารับการทดสอบ
                      </label>

                      {/* <!-- Horizontal Form --> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="col-md-12 col-12 gap-3 d-flex justify-content-center">
            <Button
              variant="primary"
              onClick={handleAbsent}
              style={{
                backgroundColor: "rgb(2, 117, 216,0.80)",
                border: "none",
              }}
            >
              ยืนยัน
            </Button>
            <Button variant="secondary" onClick={handleClose}>
              ยกเลิก / ย้อนกลับ
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalAbsent;
